import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import Presenters from '@/images/SPPlus.png';
import { useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';

import LetsTalkModal from './LetsTalkModal';

interface Props {
    onClose: () => void;
    isPremiumPlus: boolean;
}
export const UpgradeModal = ({ onClose, isPremiumPlus }: Props) => {
    const { user } = useAuth();

    const planGroup = user?.planGroup || PlanGroup.GUEST;
    const isBelowPro = [PlanGroup.GUEST, PlanGroup.TRIAL, PlanGroup.LITE].includes(planGroup);
    const avatarType = isPremiumPlus ? 'Premium+' : 'Express';

    if (isBelowPro) {
        return (
            <UpgradePlanModal
                open
                onClose={onClose}
                title={<div>Upgrade to create {avatarType} Avatars</div>}
                imageFile={Presenters}
                features={[
                    'Additional credits',
                    '100+ Languages & accents',
                    'Access to plug-ins',
                    'API access',
                    'AI Avatars creation ',
                    'Auto generated scripts',
                ]}
                from="increase packages modal"
                ctaText="Upgrade plan"
            />
        );
    }

    if (planGroup === PlanGroup.PRO) {
        return (
            <UpgradePlanModal
                open
                onClose={onClose}
                title={<div>Upgrade to create more {avatarType} Avatars</div>}
                imageFile={Presenters}
                features={[
                    'Additional credits',
                    'AI generated Avatars',
                    'Access to plugins',
                    'API access',
                    '100+ Languages & accents',
                    'Auto generated scripts',
                ]}
                from="increase packages modal"
                ctaText="Upgrade plan"
            />
        );
    }

    return <LetsTalkModal open onClose={onClose} avatarType={avatarType} />;
};
